const checkForMobileSafari = () => {
    return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
}

const isMobileSafari = checkForMobileSafari();

export {
    isMobileSafari
}
